/**
 * Clear cookie and localStorage
 */

export function clearCookie() {
  localStorage.removeItem('currentUser');

  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);

  if (keys) {
    for (let i = keys.length; i--; ) {
      document.cookie =
        keys[i] + '=0; expire=' + new Date(0).toUTCString() + '; path=/';
    }
  }
}
